import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const AboutPage = () => {



  return (
    <div className="min-h-screen page-enter" style={{background: 'linear-gradient(to bottom right, #0f172a, #1e293b, #334155)'}}>
      
      {/* Clean Header Section - No Background Images */}
      <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
        <div className="slide-in-top relative z-30">
          <Navigation />
        </div>
        
        {/* Floating Accent Images - Non-intrusive */}
        <div className="absolute top-24 left-8 z-10 hidden lg:block opacity-20 stagger-3">
          <div className="w-32 h-40 rounded-xl overflow-hidden shadow-xl transform rotate-12 gallery-item">
            <img src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/ww5y33fu_IMG_4557.jpg" className="w-full h-full object-cover" alt="accent" />
          </div>
        </div>
        
        <div className="absolute top-32 right-8 z-10 hidden lg:block opacity-20 stagger-4">
          <div className="w-28 h-36 rounded-xl overflow-hidden shadow-xl transform -rotate-12 gallery-item">
            <img src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/l38vboq7_IMG_4417.jpg" className="w-full h-full object-cover" alt="accent" />
          </div>
        </div>
        
        {/* Clean Text Header */}
        <div className="pt-20 pb-20 px-6 relative z-20">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block p-1 rounded-full bg-gradient-to-r from-blue-400/80 to-purple-500/80 mb-6 slide-in-bottom">
              <div className="bg-slate-900/90 rounded-full px-4 py-1">
                <span className="text-blue-300 text-xs font-medium">Adventure Awaits</span>
              </div>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 drop-shadow-2xl stagger-1">
              About takeatrip NYC
            </h1>
            <div className="w-16 h-0.5 bg-gradient-to-r from-blue-400 to-purple-500 mx-auto rounded-full stagger-2"></div>
          </div>
        </div>
      </div>

      {/* Creative Image Gallery Section 1 - Instagram Style */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="max-w-8xl mx-auto px-6">
          <div className="grid grid-cols-12 gap-6 h-[600px]">
            {/* Hero image - Extra large */}
            <div className="col-span-12 md:col-span-7 group cursor-pointer rounded-[2rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-2 hover:rotate-1 relative gallery-item slide-in-left">
              <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/02oxkx1u_Picture%2011.jpg" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{objectPosition: 'center 40%'}} alt="TakeATrip NYC Sign" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            
            {/* Vertical stack on right */}
            <div className="col-span-12 md:col-span-5 flex flex-col gap-6">
              {/* Top right - tall */}
              <div className="flex-1 group cursor-pointer rounded-[2rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-3 hover:-rotate-2 gallery-item slide-in-right stagger-1">
                <img src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/b6oek8ll_IMG_4391.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 35%'}} alt="Community Brothers" />
              </div>
              
              {/* Bottom right - medium */}
              <div className="h-48 group cursor-pointer rounded-[2rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-1 hover:rotate-3 gallery-item slide-in-right stagger-2">
                <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/5nxiryai_Picture%206.png" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 30%'}} alt="Community Group" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section - Clean Text */}
      <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 mb-8">
            <div className="bg-white rounded-full px-6 py-2">
              <span className="text-cyan-600 text-sm font-medium">Our Mission</span>
            </div>
          </div>
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100">
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              takeatrip nyc is an events & excursions platform designed for early-career professionals in white-collar industries. Driven by our mission to close access gaps in popular industry hobbies & activities that are often financially or socially out of reach, we curate beginner-friendly, community-first experiences across ski trips, adventure and leisure travel, and more.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Join a growing community in NYC to connect with people with similar cultural backgrounds and professional ambitions, organically grow your network, and try something new that you just might like.
            </p>
          </div>
        </div>
      </section>

      {/* Creative Image Gallery Section 2 - Pinterest Masonry Style */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-white relative">
        <div className="max-w-8xl mx-auto px-6">
          <div className="grid grid-cols-12 gap-8 h-[500px]">
            {/* Left side - Stacked */}
            <div className="col-span-12 md:col-span-4 flex flex-col gap-6">
              <div className="h-72 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-2 hover:rotate-2 relative">
                <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/3z9bjb55_Picture%208.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="NYC Nightlife Community" />
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <div className="h-56 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-4 hover:-rotate-1">
                <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/exm68bwl_Picture%209.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 35%'}} alt="Community Group" />
              </div>
            </div>
            
            {/* Center - Extra large hero */}
            <div className="col-span-12 md:col-span-4 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-1 hover:-rotate-1 relative">
              <img src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/f0dbb549_IMG_4426.jpg" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{objectPosition: 'center 40%'}} alt="TakeATrip Events" />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            
            {/* Right side - Single tall */}
            <div className="col-span-12 md:col-span-4 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-3 hover:rotate-2">
              <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/gosnvelq_Picture%203.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="Professional Community" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section - Clean Text */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block p-1 rounded-full bg-gradient-to-r from-purple-400 to-pink-500 mb-8">
              <div className="bg-white rounded-full px-6 py-2">
                <span className="text-purple-600 text-sm font-medium">Our Story</span>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 shadow-xl border border-slate-100">
            <div className="space-y-6">
              <p className="text-lg text-slate-700 leading-relaxed">
                Having begun our careers on Wall Street, we experienced firsthand how relationships built on shared interests, hobbies, and experiences resulted in more transformative interactions than those based on professional merit alone.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                And although everyone doesn't grow up with the ability or the means to partake in the exclusive activities that are popular in white-collar industries, this alone should not prevent us from exploring them.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                As a result, takeatrip nyc was born from the need to bridge the gap between accessibility and aspiration for young professionals of color.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                We believe that shared adventure creates lasting bonds and opens doors to new relationships that extend far beyond the trips themselves.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                Through our partnership with the nonprofit startswithus, we're committed to building authentic communities that support personal and professional growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Creative Image Gallery Section 3 - Magazine Layout Style */}
      <section className="py-20 bg-white relative">
        <div className="max-w-8xl mx-auto px-6">
          <div className="grid grid-cols-12 gap-8">
            {/* Two wider images - equal sizes */}
            <div className="col-span-12 md:col-span-6 h-80 group cursor-pointer rounded-[3rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-2 hover:rotate-1 relative">
              <img src="https://customer-assets.emergentagent.com/job_faq-central/artifacts/l1d66vw1_Picture%2012.jpg" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{objectPosition: 'center 40%'}} alt="Professional Community Group" />
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            
            <div className="col-span-12 md:col-span-6 h-80 group cursor-pointer rounded-[3rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-4 hover:-rotate-2">
              <img src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/l38vboq7_IMG_4417.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="DJ Music Events" />
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section - Clean Text */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block p-1 rounded-full bg-gradient-to-r from-emerald-400 to-cyan-500 mb-8">
              <div className="bg-white rounded-full px-6 py-2">
                <span className="text-emerald-600 text-sm font-medium">What We Offer</span>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4 bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 text-center border border-slate-100 hover:border-blue-200">
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg bg-gradient-to-br from-blue-100 to-blue-200 group-hover:scale-110">
                  <svg className="w-8 h-8 transition-colors duration-300 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-4">Beginner-Friendly</h3>
              <p className="text-slate-600 leading-relaxed">No-hassle trips and experiences designed with beginners & first-timers in mind</p>
            </div>

            <div className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4 bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 text-center border border-slate-100 hover:border-purple-200">
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg bg-gradient-to-br from-purple-100 to-purple-200 group-hover:scale-110">
                  <svg className="w-8 h-8 transition-colors duration-300 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-4">All-Inclusive</h3>
              <p className="text-slate-600 leading-relaxed">One package for all of your needs</p>
            </div>

            <div className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4 bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 text-center border border-slate-100 hover:border-emerald-200">
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg bg-gradient-to-br from-emerald-100 to-emerald-200 group-hover:scale-110">
                  <svg className="w-8 h-8 transition-colors duration-300 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-4">Year-Round</h3>
              <p className="text-slate-600 leading-relaxed">Year-round calendar of curated excursions, events, and experiences from NYC to wherever</p>
            </div>

            <div className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4 bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 text-center border border-slate-100 hover:border-cyan-200">
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg bg-gradient-to-br from-cyan-100 to-cyan-200 group-hover:scale-110">
                  <svg className="w-8 h-8 transition-colors duration-300 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-4">Authentic Community</h3>
              <p className="text-slate-600 leading-relaxed">A community of authentic, real people with shared culture and ambitions</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;